/* eslint-disable @typescript-eslint/no-explicit-any */

import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { RoutingService } from './routing.service';
import { AuthService } from './auth.service';
import { QueryApiService } from '../shared/services/customer-api/query-api.service';
import { PortfolioApiService } from '../shared/services/customer-api/portfolio-api.service';
import { ConfigService } from './config.service';
import * as moment from 'moment';
import { Observable, forkJoin, throwError, of } from 'rxjs';
import { catchError, map, mergeMap, timeout, switchMap } from 'rxjs/operators';
import { INTERNAL_COCKPIT_SETTINGS } from 'src/app/shared/utils/cockpit-constants';

/**
 * This service is the most impostant basically it request all the data relative to the sentiment
 */

@Injectable()
export class YukkApi {
  apiurl: string;
  apiurlQuant: string;
  apiurlMetadata: string;
  paramsForAllRequests = [
    'from',
    'to',
    'lang',
    'feed',
    'categories',
    'continents',
    'countries',
    'factuality',
    'temporality',
    'ranks',
    'panels',
  ];
  project: string;

  /**
   * constructor
   */
  constructor(
    private http: HttpClient,
    public routing: RoutingService,
    public auth: AuthService,
    private queryApi: QueryApiService,
    public config: ConfigService,
    public portfolioApi: PortfolioApiService,
  ) {
    this.project = this.config.appConfig.routing.apiproj;
    this.apiurl = this.config.appConfig.urlDataApi;
    this.apiurlQuant = this.config.appConfig.urlQuantApi;
    this.apiurlMetadata = this.config.appConfig.urlMetadataApi;
  }

  // ERROR ---------------------------------------------------------------------

  /**
   * console error of the request
   */
  private handleError(error: HttpErrorResponse) {
    if (error) {
      if (error.error instanceof Error) {
        console.error('An error occurred:', error.error.message);
      } else if (error.error) {
        console.error(
          `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`,
        );
        // 401 handling is centralized in AuthInterceptor
      }
    }
    return throwError(
      () => new Error('Something bad happened please try again later.'),
    );
  }

  /**
   * here we start the request based on the url path
   * @param iparams url parameters everything about the cockpit decides the functinolity of the request or which type of request it should be
   * @param paramsArg data_api parameters query paramaters for request what send to the api
   * @param typeArg endpoint of the request
   *
   */
  iRequest(iparams, paramsArg, typeArg) {
    if (iparams.changeDataApi === true || iparams.changeDataApi === 'true') {
      // this.apiurl = 'https://api.yukkalab.com/api-data/7-2';
    }

    const tradingEndpoints = [
      'score_ts_industry_bench_itemized',
      'score_ts_industry_bench',
    ];

    const bbEndpoints = [
      'bull_bear_score_ts',
      'bull_bear_score_ts_itemized',
      'bull_bear_score_ts_industry_bench_itemized',
      'bull_bear_score_ts_industry_bench',
      'bull_bear_score_ts_top_events',
      'bull_bear_score_ts_weights',
    ];

    const v2Endpoints = [
      'related_entities',
      'related_events_participants',
      'score_ts_itemized',
      'score_ts_top_events',
      'quotient_ts_itemized',
      // 'news',
      'newsview',
      'top_sources',
    ];

    let type = typeArg;

    let requestUrlBase = this.apiurl + '/api';
    if (tradingEndpoints.includes(type)) {
      requestUrlBase = this.apiurlQuant + '/trading';
    } else if (bbEndpoints.includes(type)) {
      requestUrlBase = this.apiurlQuant + '/trading/v3';
    } else if (v2Endpoints.includes(type)) {
      requestUrlBase = this.apiurl + '/v2/api';
    } else if (type === 'news') {
      requestUrlBase = this.apiurl + '/v3/api';
    } else if (type === 'top_news') {
      requestUrlBase = this.apiurl + '/v2/api';
      type = 'stories';
    }

    let request: any;
    const params = paramsArg;
    if (this.routing.isChart2() && type === 'multi_trend_radar') {
      params['no_binning'] = true;
    }

    if (type === 'score_ts_weights') {
      const requestUrl = `${requestUrlBase}/all/all/score_ts_weights`;
      request = this.http.get(requestUrl, this.getOption(params));
    } else if (type === 'bull_bear_score_ts_weights') {
      const requestUrl = `${requestUrlBase}/all/all/bull_bear_score_ts_weights`;
      request = this.http.get(requestUrl, this.getOption(params));
    } else if (
      (type === 'news' || type === 'stories') &&
      iparams.id === 'icb' &&
      iparams.type === 'hierarchy'
    ) {
      if (type === 'score_ts') {
        type = 'mean_score_ts';
      }
      const requestUrl = `${requestUrlBase}/portfolio/${type}`;
      request = this.getHierarchyInfo('icb', iparams).pipe(
        mergeMap((resArg) => {
          const res = JSON.parse(JSON.stringify(resArg));
          const industries = [];
          res.treemap.children.forEach((industry) => {
            industries.push(industry.entity.compound_key);
          });
          return this.http.post(requestUrl, industries, this.getOption(params));
        }),
      );
    } else if (type === 'quotient_ts_itemized' && iparams.custom_payload) {
      if (type === 'score_ts') {
        type = 'mean_score_ts';
      }
      const requestUrl = `${requestUrlBase}/portfolio/${type}`;
      request = this.http.post(
        requestUrl,
        iparams.custom_payload,
        this.getOption(params),
      );
    } else if (
      (type === 'news' || type === 'stories' || type === 'semantic_search') &&
      iparams.newsfeedFromQuery &&
      this.auth.queryForNewsfeed
    ) {
      const requestUrl = `${requestUrlBase}/search_query/${type}`;
      request = this.http
        .post(
          requestUrl,
          this.auth.queryForNewsfeed.query.query,
          this.getOption(params),
        )
        .pipe(
          map((res) => res),
          catchError(() => of(undefined)),
        );
    } else if (type === 'newsview') {
      if (this.routing.isFolio() && !iparams.portfolioId) {
        const requestUrl = `${requestUrlBase}/all/all/news_item/${iparams.newsId}`;
        request = this.http.get(requestUrl, this.getOption(params));
      } else if (this.routing.isQuery() || this.routing.isSearch()) {
        const requestUrl = `${requestUrlBase}/search_query/news_item/${iparams.newsId}`;
        // request = this.http.get(requestUrl, this.getOption(params));
        request = this.http.post(
          requestUrl,
          this.auth.query.query,
          this.getOption(params),
        );
      } else if (this.routing.isMarket() || iparams.portfolioId) {
        let requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/news_item/${iparams.newsId}`;
        if (iparams.id === 'icb' && iparams.type === 'hierarchy') {
          requestUrl = `${requestUrlBase}/all/all/news_item/${iparams.newsId}`;
        }
        request = this.http.get(requestUrl, this.getOption(params));
      } else if (this.routing.isNewsletter()) {
        if (
          iparams['type'] === 'portfolio' ||
          iparams['type'] === 'search_query'
        ) {
          const requestUrl = `${requestUrlBase}/${iparams['type']}/news_item/${iparams.newsId}`;
          request = this.http.post(
            requestUrl,
            iparams['payload'],
            this.getOption(params),
          );
        } else {
          const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/news_item/${iparams.newsId}`;
          request = this.http.get(requestUrl, this.getOption(params));
        }
      } else {
        const options = this.getOption(params);
        const requestUrl = `${requestUrlBase}/all/all/news_item/${iparams.newsId}`;
        request = this.http.get(requestUrl, options);
      }
    } else if (iparams.fromAlertsSetup) {
      const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
      request = this.http.get(requestUrl, this.getOption(params));
    } else if (iparams.fromHomeGuard && iparams.array) {
      if (this.portfolioApi.portfolios) {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestArray = [];
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        this.portfolioApi.portfolios.forEach((portfolio) => {
          const req = this.http.post(
            requestUrl,
            portfolio.content,
            this.getOption(params),
          );
          requestArray.push(req);
        });
        request = forkJoin(requestArray);
      } else {
        request = of([]);
      }
    } else if (iparams.iquery) {
      const requestUrl = `${requestUrlBase}/search_query/${type}`;
      request = this.queryApi.resolveQuery(iparams.iquery.uid).pipe(
        switchMap((response) =>
          this.http
            .post(requestUrl, response.query, this.getOption(params))
            .pipe(
              map((res) => res),
              catchError(() => of(undefined)),
            ),
        ),
      );
    } else if (
      this.routing.isScanner() &&
      iparams.tag &&
      !iparams.type &&
      !iparams.scoreForTabs &&
      !iparams.itemized
    ) {
      const tagType = iparams.tag.split(':')[1];
      const tagId = iparams.tag.split(':')[2];
      const requestUrl = `${requestUrlBase}/${tagType}/${tagId}/${type}`;
      request = this.http.get(requestUrl, this.getOption(params)).pipe(
        map((res) => res),
        catchError(() => of({})),
      );
    } else if (
      ((this.routing.isFolio() || this.routing.isScanner()) &&
        (iparams.scorePortfolio ||
          iparams.scoreForPortfolio ||
          iparams.scoreScanner)) ||
      iparams.usePortfolio
    ) {
      if (iparams.scoreForPortfolio || iparams.usePortfolio) {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        let body;
        if (iparams.custom_payload) {
          body = iparams.custom_payload;
        } else {
          body = this.portfolioApi.activePortfolio
            ? this.portfolioApi.activePortfolio.content
            : [];
        }
        request = this.http.post(requestUrl, body, this.getOption(params));
      } else {
        const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params)).pipe(
          map((res) => res),
          catchError(() => of({})),
        );
      }
    } else if (this.routing.isMarket() || iparams.portfolioId) {
      if (iparams.portfolio) {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        if (this.portfolioApi.portfolios) {
          request = this.portfolioApi.portfolios
            .filter((portfolio) => {
              return portfolio.uid === iparams.portfolioId;
            })
            .map((item) => {
              const payload = item.content;
              return this.http
                .post(requestUrl, payload, this.getOption(params))
                .pipe(
                  map((res) => res),
                  catchError(() => of(undefined)),
                );
            })[0];
        } else {
          request = of({});
        }
      } else if (
        this.portfolioApi.activePortfolio &&
        this.portfolioApi.activePortfolio.marketPortfolio
      ) {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        const payload = this.portfolioApi.activePortfolio.content;
        return this.http.post(requestUrl, payload, this.getOption(params)).pipe(
          map((res) => res),
          catchError(() => of(undefined)),
        );
      } else {
        const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params));
      }
    } else if (this.routing.isFolio() && !iparams.portfolioId) {
      if (iparams.requestEntity) {
        const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params));
      } else if (iparams.array === true) {
        if (this.portfolioApi.portfolios) {
          if (type === 'score_ts') {
            type = 'mean_score_ts';
          }
          const requestArray = [];
          const requestUrl = `${requestUrlBase}/portfolio/${type}`;
          this.portfolioApi.portfolios.forEach((portfolio) => {
            const req = this.http.post(
              requestUrl,
              portfolio.content,
              this.getOption(params),
            );
            requestArray.push(req);
          });
          request = forkJoin(requestArray);
        } else {
          request = of([]);
        }
      } else {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        let body = [];
        if (this.routing.isChart2() && this.auth.payloadEntities.length) {
          body = this.auth.payloadEntities;
        } else {
          body = this.portfolioApi.activePortfolio
            ? this.portfolioApi.activePortfolio.content
            : [];
        }
        request = this.http.post(requestUrl, body, this.getOption(params));
      }
    } else if (this.routing.isQuery() || this.routing.isSearch()) {
      let requestUrl = `${requestUrlBase}/search_query/${type}`;
      if (type === 'multi_trend_radar') {
        requestUrl = `${requestUrlBase}/search_query/quotient_ts`;
      }
      if (iparams.array === true) {
        if (this.auth.querys) {
          const requestArray = [];
          this.auth.querys.forEach((query) => {
            const payload = {
              operator: 'or',
              filters: [],
              groups: query.content.map((item) => {
                return item.query;
              }),
            };
            const req = this.http
              .post(requestUrl, payload, this.getOption(params))
              .pipe(
                map((res) => res),
                catchError(() => of(undefined)),
              );
            requestArray.push(req);
          });
          request = forkJoin(requestArray);
        } else {
          request = of([]);
        }
      } else if (iparams.collection && iparams.id !== iparams.groupId) {
        if (this.auth.querys) {
          request = this.auth.querys
            .filter((collection) => {
              return collection.uid === iparams.groupId;
            })
            .map((item) => {
              const payload = {
                operator: 'or',
                filters: [],
                groups: item.content.map((item2) => {
                  return item2.query;
                }),
              };
              return this.http
                .post(requestUrl, payload, this.getOption(params))
                .pipe(
                  map((res) => res),
                  catchError(() => of(undefined)),
                );
            })[0];
        } else {
          request = of([]);
        }
      } else if (
        this.auth.iquery &&
        this.routing.isQuery() &&
        (this.routing.isChart2() || this.routing.isRadar()) &&
        (type === 'multi_trend_radar' || type === 'related_events_participants')
      ) {
        const requestArray = [];
        let mainReq = null;
        if (this.auth.query && iparams.groupId !== iparams.id) {
          mainReq = this.queryApi.resolveQuery(this.auth.query.uid).pipe(
            switchMap((response) =>
              this.http
                .post(requestUrl, response.query, this.getOption(params))
                .pipe(
                  map((res) => res),
                  catchError(() => of(undefined)),
                ),
            ),
          );
        } else {
          mainReq = this.queryApi.resolveQueryGroup(this.auth.query.uid).pipe(
            switchMap((response) => {
              const payload = {
                operator: 'or',
                filters: [],
                groups: response.content.map((item) => {
                  return item.query;
                }),
              };
              return this.http
                .post(requestUrl, payload, this.getOption(params))
                .pipe(
                  map((res) => res),
                  catchError(() => of(undefined)),
                );
            }),
          );
        }
        // const mainReq = this.http.post(requestUrl, this.auth.query.query, this.getOption(params)).pipe(map((res) => res), catchError(error => of(undefined)));
        requestArray.push(mainReq);
        this.auth.iquery.forEach((item) => {
          const req = this.queryApi.resolveQuery(item.uid).pipe(
            switchMap((response) =>
              this.http
                .post(requestUrl, response.query, this.getOption(params))
                .pipe(
                  map((res) => res),
                  catchError(() => of(undefined)),
                ),
            ),
          );
          // const req = this.http.post(requestUrl, item.query, this.getOption(params)).pipe(map((res) => res), catchError(error => of(undefined)));
          requestArray.push(req);
        });
        request = forkJoin(requestArray);
      } else {
        if (this.routing.isSearch()) {
          request = this.http
            .post(requestUrl, this.auth.query.query, this.getOption(params))
            .pipe(
              map((res) => res),
              catchError((error) => this.handleError(error)),
            );
        } else if (this.auth.query && iparams.groupId !== iparams.id) {
          request = this.queryApi.resolveQuery(this.auth.query.uid).pipe(
            switchMap((response) =>
              this.http
                .post(requestUrl, response.query, this.getOption(params))
                .pipe(
                  map((res) => res),
                  catchError((error) => this.handleError(error)),
                ),
            ),
          );
        } else {
          request = this.queryApi.resolveQueryGroup(this.auth.query.uid).pipe(
            switchMap((response) => {
              const payload = {
                operator: 'or',
                filters: [],
                groups: response.content.map((item) => {
                  return item.query;
                }),
              };
              return this.http
                .post(requestUrl, payload, this.getOption(params))
                .pipe(
                  map((res) => res),
                  catchError((error) => this.handleError(error)),
                );
            }),
          );
        }
      }
    } else if (this.routing.isWidget()) {
      if (
        (this.routing.getPathSegment(2) === 'portfolio' ||
          iparams['type'] === 'portfolio') &&
        !iparams.portfolioId
      ) {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        request = this.http.post(
          requestUrl,
          this.portfolioApi.activePortfolio.content,
          this.getOption(params),
        );
      } else if (this.routing.getPathSegment(2) === 'query') {
        const requestUrl = `${requestUrlBase}/search_query/${type}`;
        request = this.http.post(
          requestUrl,
          this.auth.query.query,
          this.getOption(params),
        );
      } else if (iparams.isin) {
        const requestUrl = `${requestUrlBase}/isin/${iparams['isin']}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params));
      } else if (
        iparams.type &&
        iparams.type === 'search_query' &&
        iparams.id &&
        this.auth &&
        this.auth.iquery
      ) {
        const requestUrl = `${requestUrlBase}/search_query/${type}`;
        const query = this.auth.iquery.filter((item) => {
          return item.uid === iparams.id;
        })[0]?.query;
        request = this.http.post(requestUrl, query, this.getOption(params));
      } else {
        const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params));
      }
    } else if (this.routing.isNewsletter()) {
      if (type === 'news' || type === 'stories' || type === 'semantic_search') {
        if (
          iparams['type'] === 'portfolio' ||
          iparams['type'] === 'search_query'
        ) {
          const requestUrl = `${requestUrlBase}/${iparams['type']}/${type}`;
          request = this.http.post(
            requestUrl,
            iparams['payload'],
            this.getOption(params),
          );
        } else {
          const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
          request = this.http.get(requestUrl, this.getOption(params));
        }
      } else {
        const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params));
      }
    } else if (this.routing.isHomepage()) {
      if (type === 'news') {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        let body = [];
        body =
          this.portfolioApi.activePortfolio &&
          this.portfolioApi.activePortfolio.contentTop
            ? this.portfolioApi.activePortfolio.contentTop
            : [];
        request = this.http.post(requestUrl, body, this.getOption(params));
      } else {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        let body = [];
        body =
          this.portfolioApi.activePortfolio &&
          this.portfolioApi.activePortfolio.content
            ? this.portfolioApi.activePortfolio.content
            : [];
        request = this.http.post(requestUrl, body, this.getOption(params));
      }
    } else if (this.routing.isHot()) {
      if (iparams.tag) {
        const tagType = iparams.tag.split(':')[1];
        const tagId = iparams.tag.split(':')[2];
        const requestUrl = `${requestUrlBase}/${tagType}/${tagId}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params)).pipe(
          map((res) => res),
          catchError(() => of({})),
        );
      } else if (iparams.score_type) {
        const tagType = iparams.type;
        const tagId = iparams.id;
        const requestUrl = `${requestUrlBase}/${tagType}/${tagId}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params)).pipe(
          map((res) => res),
          catchError(() => of({})),
        );
      } else {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        let body = [];
        body = INTERNAL_COCKPIT_SETTINGS.portfolioInvestLab.content;
        request = this.http.post(requestUrl, body, this.getOption(params)).pipe(
          map((res) => res),
          catchError(() => of({})),
        );
      }
    } else if (this.routing.isPath('stats')) {
      if (type === 'treemap') {
        const id = iparams.id;
        const requestUrl = `${requestUrlBase}/country/${id}/${type}`;
        request = this.http.get(requestUrl, this.getOption(params)).pipe(
          map((res) => res),
          catchError(() => of({})),
        );
      } else if (type === 'related_entities') {
        if (type === 'score_ts') {
          type = 'mean_score_ts';
        }
        const requestUrl = `${requestUrlBase}/portfolio/${type}`;
        const body = iparams.body;
        request = this.http.post(requestUrl, body, this.getOption(params));
      }
    } else {
      const requestUrl = `${requestUrlBase}/${iparams['type']}/${iparams['id']}/${type}`;
      request = this.http.get(requestUrl, this.getOption(params));
    }

    this.apiurl = this.config.appConfig.urlDataApi;

    return (
      request
        // .pipe(catchError(err => of(undefined)))
        .pipe(catchError((error) => this.handleError(error)))
    );
  }

  /**
   * setup the project of the enviroment
   */
  setProject(project) {
    this.project = project;
  }

  /**
   * default parameters 4 the request
   */
  myParams(iparams, paramsToBeSent) {
    const params = {};
    params['project_id'] = this.project;
    if (paramsToBeSent.includes('lang')) {
      if (iparams.lang && iparams.lang !== 'multi') {
        params['lang'] = iparams.lang;
      }
    }
    let time = '7';
    if (this.routing.isReader() || this.routing.isStoryReader()) {
      time = '90';
    }
    if (iparams.time) {
      time = iparams.time;
    }
    const fromto = this.myFromTo(time);
    if (paramsToBeSent.includes('from')) {
      params['from'] = fromto.date1;
    }
    if (paramsToBeSent.includes('to')) {
      params['to'] = fromto.date2;
    }
    if (paramsToBeSent.includes('period')) {
      if (iparams.period) {
        params['period'] = iparams.period;
      } else {
        params['period'] = 7;
      }
    }
    if (paramsToBeSent.includes('feed')) {
      if (iparams.feed) {
        params['feed_types'] = iparams.feed;
      }
    }
    if (paramsToBeSent.includes('categories')) {
      if (iparams.categories) {
        params['exclude_document_category_filter'] = iparams.categories;
      }
    }
    if (paramsToBeSent.includes('continents')) {
      if (iparams.continents) {
        params['source_continents'] = iparams.continents;
      }
    }
    if (paramsToBeSent.includes('countries')) {
      if (iparams.countries) {
        params['source_countries'] = iparams.countries;
      }
    }
    if (paramsToBeSent.includes('factuality')) {
      if (iparams.factuality) {
        params['factuality'] = iparams.factuality;
      }
    }
    if (paramsToBeSent.includes('temporality')) {
      if (iparams.temporality) {
        params['temporality'] = iparams.temporality;
      }
    }
    if (paramsToBeSent.includes('ranks')) {
      if (iparams.ranks) {
        params['source_ranks'] = iparams.ranks;
      }
    }
    if (paramsToBeSent.includes('panels')) {
      if (iparams.panels) {
        params['source_panels'] = iparams.panels;
      }
    }
    if (paramsToBeSent.includes('event_ids')) {
      if (iparams.event_ids) {
        params['event_ids'] = iparams.event_ids;
      }
    }
    if (paramsToBeSent.includes('tag')) {
      if (iparams.tag && iparams.tag.split(':').length === 3) {
        params['tag'] = iparams.tag.split('|')[0];
      }
    }
    if (paramsToBeSent.includes('participant')) {
      if (iparams.participant) {
        params['with_contained_events_participant'] = iparams.participant;
      }
    }
    if (paramsToBeSent.includes('with_top_events')) {
      if (iparams.with_top_events) {
        params['with_top_events'] = iparams.with_top_events;
      }
    }
    if (paramsToBeSent.includes('with_all_events')) {
      if (iparams.with_all_events) {
        params['n_events'] = -1;
      }
    }
    if (paramsToBeSent.includes('temporality')) {
      if (iparams.temporality && iparams.temporality === 'na') {
        params['temporality'] = 'NONE,UNKNOWN';
      } else if (iparams.temporality) {
        params['temporality'] = iparams.temporality;
      }
    }
    if (paramsToBeSent.includes('factuality') && iparams.factuality) {
      const factuality = [];
      if (iparams.factuality && iparams.factuality.includes('na')) {
        // params['factuality'] = 'NONE,UNKNOWN';
        factuality.push('NONE,UNKNOWN');
      }
      if (iparams.factuality && iparams.factuality.includes('fact')) {
        // params['factuality'] = 'FACT,COUNTERFACT';
        factuality.push('FACT,COUNTERFACT');
      }
      if (iparams.factuality && iparams.factuality.includes('probable')) {
        // params['factuality'] = 'PROBABLE,COUNTERPROBABLE';
        factuality.push('PROBABLE,COUNTERPROBABLE');
      }
      if (iparams.factuality && iparams.factuality.includes('possible')) {
        // params['factuality'] = 'POSSIBLE,COUNTERPOSSIBLE';
        factuality.push('POSSIBLE,COUNTERPOSSIBLE');
      }
      params['factuality'] = factuality.join(',');
    }
    return params;
  }

  /**
   * return from, to and period from the time parameter
   * @deprecated Use DateUtils.fromTo() from shared/utils/date.utils.ts instead
   */
  myFromTo(value) {
    if (!isNaN(value)) {
      const daysToBeIncluded =
        value !== 1 && value !== 2 && value !== '1' && value !== '2'
          ? value
          : value - 1;
      const date1 = moment()
        .subtract(daysToBeIncluded, 'days')
        .format('YYYY-MM-DD');
      const date2 = moment().add(1, 'days').format('YYYY-MM-DD');
      const period = parseInt(value, null);
      const time = { date1, date2, period };
      return time;
    } else {
      const date = value.split('--');
      const date1 = moment(date[0]).format('YYYY-MM-DD');
      const date2 = moment(date[1]).add(1, 'days').format('YYYY-MM-DD');
      const a = moment(date[0]);
      const b = moment(date[1]);
      const period = -a.diff(b, 'days');
      const time = { date1, date2, period };
      return time;
    }
  }

  /**
   * Builds request options including the Authorization header.
   *
   * LEGACY AUTH PATH — retained until the remaining yukkapi methods are extracted
   */
  getOption(params): {
    headers: HttpHeaders;
    params: Record<string, string | number | boolean | undefined>;
  } {
    const startDay = this.config.appConfig.setup.startDate;

    if (params && params['from'] && params['from'] < startDay) {
      params['from'] = this.myFromTo(
        this.config.appConfig.setup.startDate,
      ).date1;
    }

    if (params && params['to'] && params['to'] < startDay) {
      params['to'] = moment(
        this.myFromTo(this.config.appConfig.setup.startDate).date1,
      )
        .add(1, 'days')
        .format('YYYY-MM-DD');
    }

    if (params && params['from'] && params['to'] && !params['izoom']) {
      const days = moment(params['to']).diff(moment(params['from']), 'days');
      const maxDays = INTERNAL_COCKPIT_SETTINGS.maxTimeframe;
      if (!this.routing.isDev() && !this.routing.isWidget() && days > maxDays) {
        params['from'] = moment(params['to'])
          .subtract(maxDays, 'days')
          .format('YYYY-MM-DD');
      }
    }

    if (params && params['izoom']) {
      delete params['izoom'];
    }

    let token = null;
    if (params && params.jwt) {
      if (this.config.appConfig.setup.useStorage) {
        token =
          !this.routing.isReader() && !this.routing.isStoryReader()
            ? localStorage.getItem('tokenDataAccess')
            : params.jwt;
      } else {
        token = params.jwt;
      }
    } else {
      if (this.config.appConfig.setup.useStorage) {
        token = localStorage.getItem('tokenDataAccess');
      }
    }
    if (params && params.jwt) {
      delete params['jwt'];
    }

    // changes needed to reflect FastAPI migration
    if (params && params['to']) {
      params['date_to'] = params['to'];
      delete params['to'];
    }
    if (params && params['from']) {
      params['date_from'] = params['from'];
      delete params['from'];
    }

    if (!token && this.auth.tokenDataAccess) {
      token = this.auth.tokenDataAccess;
    }

    // adding dynamic headers
    const headersObject = {
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
    };
    if (
      params &&
      Object.prototype.hasOwnProperty.call(params, 'headerIncludeNewsIds')
    ) {
      headersObject['Include-News-Ids'] = params['headerIncludeNewsIds'];
      delete params['headerIncludeNewsIds'];
    }
    if (
      params &&
      Object.prototype.hasOwnProperty.call(params, 'headerExcludeNewsIds')
    ) {
      headersObject['Exclude-News-Ids'] = params['headerExcludeNewsIds'];
      delete params['headerExcludeNewsIds'];
    }

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (typeof value === 'string' || value instanceof String) {
          params[key] = value.split(',');
        }
      });
    }

    return {
      params: params,
      headers: new HttpHeaders(headersObject),
    };
  }

  /**
   * list of top trending companies
   */
  trending(iparams): Observable<any> {
    const paramsToBeSent = ['from', 'to', 'time'];
    const params = this.myParams(iparams, paramsToBeSent);
    if (iparams.amount) {
      params['amount'] = iparams.amount;
    }
    // if (iparams.time_horizon) { params['default_time_back'] = iparams.time_horizon; }
    const options = this.getOption(params);
    const requestUrl = `${this.apiurlQuant}/signal/v2/trending`;
    let token = null;
    if (iparams && iparams.jwt) {
      if (this.config.appConfig.setup.useStorage) {
        token =
          !this.routing.isReader() && !this.routing.isStoryReader()
            ? localStorage.getItem('tokenDataAccess')
            : iparams.jwt;
      } else {
        token = iparams.jwt;
      }
    } else {
      if (this.config.appConfig.setup.useStorage) {
        token = localStorage.getItem('tokenDataAccess');
      }
    }
    if (!token && this.auth.tokenDataAccess) {
      token = this.auth.tokenDataAccess;
    }
    // const requestUrl = `https://cockpit-dev.api.yukkalab.com/9-3-5/2023-06-06/trending/trending_view?access_token=` + token;
    const payload = {
      filters: {
        scores: [],
        universe: {
          industry: iparams.industry ? iparams.industry : [],
          supersector: [],
          sector: [],
          subsector: [],
          index: iparams.stock_index ? iparams.stock_index : [],
          country: iparams.country ? iparams.country : [],
        },
        events: iparams.events ? iparams.events : [],
      },
      sorting: {
        score_type: iparams.sort_type ? iparams.sort_type : 'sentiment',
        direction: iparams.sort_value ? iparams.sort_value : 'desc',
      },
      response_columns: iparams.columns ? iparams.columns : [],
    };
    return this.http.post(requestUrl, payload, options);
  }

  /**
   * treemap data for the market board and the company page
   */
  treemap(iparams): Observable<any> {
    if (iparams && iparams.type && iparams.type === 'hierarchy') {
      if (iparams.id && ['industry', 'country', 'index'].includes(iparams.id)) {
        return this.getHierarchyInfo(iparams.id, iparams);
      } else {
        return this.getHierarchyInfo('icb', iparams).pipe(
          mergeMap((resArg) => {
            const res = JSON.parse(JSON.stringify(resArg));
            const requestSentimentList = [];
            const industries = [];
            res.treemap.children.forEach((industry) => {
              industries.push(industry.entity.compound_key);
              const supersectors = [];
              industry.children.forEach((supersector) => {
                supersectors.push(supersector.entity.compound_key);
              });
              requestSentimentList.push(
                this.sentimentItemized(iparams, supersectors),
              );
            });
            requestSentimentList.unshift(
              this.sentimentItemized(iparams, industries),
            );
            return forkJoin(requestSentimentList).pipe(
              map((resArg2) => {
                const res2 = JSON.parse(JSON.stringify(resArg2));
                const responseObject = Object.assign({}, res);
                responseObject.treemap.children.forEach((industry, index) => {
                  responseObject.treemap.children[index] = Object.assign(
                    {},
                    responseObject.treemap.children[index],
                    res2[0][industry.entity.compound_key],
                  );
                  responseObject.treemap.children[index].children.forEach(
                    (supersector, index2) => {
                      responseObject.treemap.children[index].children[index2] =
                        Object.assign(
                          {},
                          responseObject.treemap.children[index].children[
                            index2
                          ],
                          res2[1 + index][supersector.entity.compound_key],
                        );
                    },
                  );
                });
                return responseObject;
              }),
            );
          }),
        );
      }
    } else if (iparams && iparams.type && iparams.type === 'company') {
      return this.relations(iparams, [
        'country',
        'industry',
        'person',
        'sector',
        'subsector',
        'supersector',
        'stock_index',
      ]).pipe(
        map((resArg) => {
          const res = JSON.parse(JSON.stringify(resArg));
          return {
            treemap: Object.assign({}, res, {
              children: Object.values(res.relations),
            }),
          };
        }),
      );
    } else if (iparams && iparams.type) {
      return this.relations(iparams, ['company']).pipe(
        map((resArg) => {
          const res = JSON.parse(JSON.stringify(resArg));
          return {
            treemap: Object.assign({}, res, {
              children: res.relations.company.children,
            }),
          };
        }),
      );
    } else {
      return of({
        treemap: {
          children: [],
        },
      });
    }
  }

  /**
   * treemap data for all events
   */
  getEventsTreemap(): Observable<any> {
    const time = '90';
    const fromto = this.myFromTo(time);
    const params = {
      from: fromto.date1,
      to: fromto.date2,
    };
    const options = this.getOption(params);
    // const options = this.getOption(null);
    return this.http.get(this.apiurl + '/api/all/all/event_treemap', options);
  }

  /**
   * treemap data for specific event
   */
  evenTreemap(type, id, iparams): Observable<any> {
    const paramsToBeSent = [...this.paramsForAllRequests];
    const params = this.myParams(iparams, paramsToBeSent);
    const options = this.getOption(params);
    return this.http.get(
      this.apiurl + '/api/' + type + '/' + id + '/event_treemap',
      options,
    );
  }

  /**
   * data from specific company
   */
  relations(iparams, types): Observable<any> {
    if (iparams.type && iparams.id) {
      const entity_type = iparams['type'];
      const entity_id = iparams['id'];
      const compoundKey = entity_type + ':' + entity_id;
      const requestMetadataList = [];
      requestMetadataList.push(this.getEntitiesInfo([compoundKey], 'array'));
      types.forEach((type) => {
        requestMetadataList.push(
          this.getRelatedEntitiesInfo(entity_type, entity_id, type),
        );
      });
      return forkJoin(requestMetadataList).pipe(
        mergeMap((resArg) => {
          const res = JSON.parse(JSON.stringify(resArg));
          const requestSentimentList = [];
          res.forEach((item) => {
            const entitiesList = [];
            item.forEach((el) => {
              entitiesList.push(el.compound_key);
            });
            requestSentimentList.push(
              this.sentimentItemized(iparams, entitiesList),
            );
          });
          res.forEach((item, index) => {
            if (index !== 0) {
              const entitiesList = [];
              item.forEach((el) => {
                entitiesList.push(el.compound_key);
              });
              requestSentimentList.push(
                this.portfolioSentiment(iparams, entitiesList, false),
              );
            }
          });
          return forkJoin(requestSentimentList).pipe(
            map((resArg2) => {
              const res2 = JSON.parse(JSON.stringify(resArg2));
              const relationTypes = {};
              types.forEach((type, index) => {
                relationTypes[type] = Object.assign(
                  {},
                  {
                    children: res[index + 1].map((el, index2) => {
                      return Object.assign(
                        {},
                        {
                          entity: res[index + 1][index2],
                        },
                        res2[index + 1][el.compound_key],
                      );
                    }),
                    name: type[0].toUpperCase() + type.slice(1),
                    entity: {
                      alpha_id: type,
                      name: type[0].toUpperCase() + type.slice(1),
                      type: 'relations',
                    },
                  },
                  res2[types.length + 1 + index]['sentiment'],
                );
              });
              const relationsObject = Object.assign({}, res2[0][compoundKey], {
                entity: res[0][0],
                relations: relationTypes,
              });
              return relationsObject;
            }),
          );
        }),
      );
    } else {
      return of({
        entity: {},
        relations: {},
      });
    }
    // if (iparams.query) {
    //   const requestUrl = `${this.apiurl}/api/search_query/relations`;
    //   return this.http.post(requestUrl, iparams.query, options);
    // }
  }

  /**
   * peergroup comparison for companies including scores
   */
  peergroupComparison(iparams): Observable<any> {
    if (iparams && iparams.id && iparams.type && iparams.type === 'company') {
      return this.getPeergroup(iparams).pipe(
        mergeMap((resArg) => {
          const res = JSON.parse(JSON.stringify(resArg));
          const content = res.companies.map((el) => el.compound_key);
          content.push(iparams.type + ':' + iparams.id);
          return this.getEntitiesInfo(content, 'array').pipe(
            mergeMap((resArg2) => {
              return this.sentimentItemized(iparams, content).pipe(
                map((resArg3) => {
                  return resArg2.map((el) => {
                    return Object.assign({}, el, resArg3[el.compound_key]);
                  });
                }),
              );
            }),
          );
        }),
      );
    } else {
      return of([]);
    }
  }

  /**
   * sentiment of a portfolio
   */
  portfolioSentiment(iparams, portfolio, newsday): Observable<any> {
    const paramsToBeSent = ['period', ...this.paramsForAllRequests];
    let params = {};
    if (iparams) {
      params = this.myParams(iparams, paramsToBeSent);
    }
    if (newsday && iparams.newsday) {
      params['from'] = moment(iparams.newsday).format('YYYY-MM-DD');
      params['to'] = moment(iparams.newsday)
        .add(1, 'days')
        .format('YYYY-MM-DD');
    }
    const options = this.getOption(params);
    const requestUrl = `${this.apiurl}/api/portfolio/sentiment`;
    return this.http.post(requestUrl, portfolio, options);
  }

  /**
   * entities of specific portfolio
   */
  sentimentItemized(iparams, portfolio): Observable<any> {
    const paramsToBeSent = ['period', ...this.paramsForAllRequests];
    let params = {};
    if (iparams) {
      params = this.myParams(iparams, paramsToBeSent);
    }
    const options = this.getOption(params);
    const requestUrl = `${this.apiurl}/v2/api/portfolio/sentiment_itemized`;
    return this.http.post(requestUrl, portfolio, options).pipe(
      map((resp) => {
        if (Object.prototype.hasOwnProperty.call(resp, 'sentiment_itemized')) {
          const respCopy = JSON.parse(
            JSON.stringify(resp['sentiment_itemized']),
          );
          const entitiesData = {};
          portfolio.forEach((el) => {
            const filteredEntity = respCopy.filter((item) => {
              return item.entity.compound_key === el;
            });
            if (filteredEntity.length > 0) {
              entitiesData[el] = filteredEntity[0].sentiment;
            } else {
              console.log(
                'The entity ' + el + ' is not present in the API response.',
              );
            }
          });
          return entitiesData;
        } else {
          return throwError(
            () => new Error('Error: wrong format of the response.'),
          );
        }
      }),
    );
  }

  /**
   * peergroup companies
   */
  getPeergroup(iparams): Observable<any> {
    const paramsToBeSent = ['period', ...this.paramsForAllRequests];
    const params = this.myParams(iparams, paramsToBeSent);
    const options = this.getOption(params);
    const requestUrl =
      this.apiurlQuant + `/misc/company/${iparams.id}/peergroup`;
    return this.http.get(requestUrl, options);
  }

  /**
   * signal list
   */
  signal(supersector_etf_id): Observable<any> {
    const options = this.getOption(null);
    const params = `/trading/supersector_etf/${supersector_etf_id}/signal`;
    const requestUrl = this.apiurlQuant + params;
    return this.http.get(requestUrl, options);
  }

  /**
   * trend lab signals' list
   */
  getSignalsList(): Observable<any> {
    const options = this.getOption(null);
    const params = `/signal/signal`;
    const requestUrl = this.apiurlQuant + params;
    return this.http.get(requestUrl, options);
  }

  /**
   * signals' data endpoint
   */
  getSignalData(type): Observable<any> {
    const options = this.getOption(null);
    const params = `/signal/${type}`;
    const requestUrl = this.apiurlQuant + params;
    return this.http.get(requestUrl, options);
  }

  /**
   * get time series of different score types
   */
  scoresTimeSeries(type, iparams, chart) {
    const customScore = this.auth.scorelabSettings.defaultScore;
    const paramsToBeSent = [
      'period',
      'with_top_events',
      'with_all_events',
      ...this.paramsForAllRequests,
    ];
    let params = {};
    params = this.myParams(iparams, paramsToBeSent);
    if (chart === 'izoom') {
      params['from'] = this.myFromTo(
        this.config.appConfig.setup.startDate,
      ).date1;
      params['to'] = moment().add(1, 'days').format('YYYY-MM-DD');
      params['izoom'] = true;
    }
    if (type === 'sentiment') {
      params['algorithm'] = 'rolling';
      if (iparams.itemized) {
        return this.iRequest(iparams, params, 'quotient_ts_itemized');
      } else {
        return this.iRequest(iparams, params, 'quotient_ts');
      }
    }
    if (type === 'volume') {
      delete params['period'];
      return this.iRequest(iparams, params, 'volume_ts');
    }
    if (
      type === 'score' ||
      type === 'scoreE' ||
      type === 'scoreS' ||
      type === 'scoreG'
    ) {
      if (
        iparams.scorePortfolio &&
        this.auth.scorelabSettings.defaultScore !== 'bb'
      ) {
        params['from'] = moment(params['to'])
          .subtract(1, 'days')
          .format('YYYY-MM-DD');
      }
      params['period'] = 30;
      if (iparams.document_category_filter) {
        delete params['document_category_filter'];
      }
      if (iparams.event_ids) {
        delete params['event_ids'];
      }

      if (iparams.requestScore) {
        if (iparams.requestScore === 'general_risk') {
          params['score_type'] = 'general_risk';
          params['with_black_swan'] = true;
          // params['document_category_filter'] = 'business,business_pro_forma';
        } else if (iparams.requestScore === 'credit_risk') {
          params['score_type'] = 'credit_watch';
          params['risk_sensitivity'] = 0;
        } else if (iparams.requestScore === 'esg_risk') {
          params['score_type'] = 'esg_risk';
          params['with_black_swan'] = true;
          // params['document_category_filter'] = 'business,business_pro_forma';
        } else if (iparams.requestScore === 'immediate_risk') {
          params['score_type'] = 'immediate_risk';
          params['with_black_swan'] = true;
        } else if (iparams.requestScore === 'esg') {
          params['score_type'] = 'esg';
          params['disable_industry_materiality'] = true;
        } else if (iparams.requestScore === 'eb_sim') {
          params['score_type'] = 'eb_sim';
        } else if (iparams.requestScore === 'eb_sim_risk') {
          params['score_type'] = 'eb_sim_risk';
        } else if (iparams.requestScore === 'bb') {
          params['time_horizon'] = '1M';
        } else {
          const defaultScoreObj =
            this.auth.scorelabSettings.customScores.filter((score) => {
              return score.uid === iparams.requestScore;
            })[0];
          if (defaultScoreObj?.sentiment_type) {
            if (defaultScoreObj.sentiment_type === 'neg') {
              params['with_black_swan'] = true;
            }
          }
          if (
            defaultScoreObj?.event_weights &&
            defaultScoreObj?.event_weights.length > 0
          ) {
            defaultScoreObj.event_weights.forEach((event) => {
              let event_id, weight, polarity;
              if (event.event_id) {
                event_id = event.event_id;
              } else {
                event_id = undefined;
              }
              if (event.weight) {
                weight = event.weight;
              } else {
                weight = 5;
              }
              if (event.polarity) {
                polarity = event.polarity;
              } else {
                polarity = -1;
              }
              // if (event.weight_persistence) {
              //   weight_persistence = event.weight_persistence;
              // } else {
              //   weight_persistence = 90;
              // }
              if (event_id) {
                params[event_id + '_weight'] = weight * polarity;
              }
            });
          }
        }
      } else if (
        iparams.score_type &&
        iparams.score_type !== 'credit_risk' &&
        iparams.score_type !== 'bb'
      ) {
        params['score_type'] = iparams.score_type;
        if (
          iparams.score_type === 'esg' ||
          iparams.score_type === 'e_standard' ||
          iparams.score_type === 's_standard' ||
          iparams.score_type === 'g_standard'
        ) {
          params['disable_industry_materiality'] = true;
        }
      } else if (type === 'scoreE') {
        params['score_type'] = 'e_standard';
        params['disable_industry_materiality'] = true;
      } else if (type === 'scoreS') {
        params['score_type'] = 's_standard';
        params['disable_industry_materiality'] = true;
      } else if (type === 'scoreG') {
        params['score_type'] = 'g_standard';
        params['disable_industry_materiality'] = true;
      } else if (customScore === 'general_risk') {
        params['score_type'] = 'general_risk';
        params['with_black_swan'] = true;
        // params['document_category_filter'] = 'business,business_pro_forma';
      } else if (customScore === 'esg_risk') {
        params['score_type'] = 'esg_risk';
        params['with_black_swan'] = true;
        // params['document_category_filter'] = 'business,business_pro_forma';
      } else if (customScore === 'immediate_risk') {
        params['score_type'] = 'immediate_risk';
        params['with_black_swan'] = true;
      } else if (customScore === 'credit_risk') {
        params['score_type'] = 'credit_watch';
        params['risk_sensitivity'] = 0;
      } else if (customScore === 'esg') {
        params['score_type'] = 'esg';
        params['disable_industry_materiality'] = true;
        // params['use_volume'] = false;
        // params['sentiment_weight'] = 0;
      } else if (customScore === 'eb_sim') {
        params['score_type'] = 'eb_sim';
      } else if (customScore === 'eb_sim_risk') {
        params['score_type'] = 'eb_sim_risk';
      } else if (customScore === 'bb') {
        params['time_horizon'] = '1M';
      } else if (
        customScore &&
        customScore !== 'credit_risk' &&
        customScore !== 'bb' &&
        this.auth.scorelabSettings?.customScores?.length > 0
      ) {
        // params['use_volume'] = false;
        const defaultScoreObj = this.auth.scorelabSettings.customScores.filter(
          (score) => {
            return score.uid === this.auth.scorelabSettings.defaultScore;
          },
        )[0];
        if (defaultScoreObj.sentiment_type) {
          // params['sentiment_type'] = defaultScoreObj.sentiment_type;
          if (defaultScoreObj.sentiment_type === 'neg') {
            params['with_black_swan'] = true;
          }
        }
        if (
          defaultScoreObj.event_weights &&
          defaultScoreObj.event_weights.length > 0
        ) {
          defaultScoreObj.event_weights.forEach((event) => {
            let event_id, weight, polarity;
            if (event.event_id) {
              event_id = event.event_id;
            } else {
              event_id = undefined;
            }
            if (event.weight) {
              weight = event.weight;
            } else {
              weight = 5;
            }
            if (event.polarity) {
              polarity = event.polarity;
            } else {
              polarity = -1;
            }

            if (event_id) {
              params[event_id + '_weight'] = weight * polarity;
            }
          });
        }
      }
      if (
        !iparams.industry_bench &&
        ((!iparams.requestScore && ['bb'].includes(customScore)) ||
          (iparams.requestScore && ['bb'].includes(iparams.requestScore)))
      ) {
        if (iparams.itemized) {
          return this.iRequest(
            iparams,
            params,
            'bull_bear_score_ts_itemized',
          ).pipe(
            map((respArg) => {
              const resp = JSON.parse(JSON.stringify(respArg));
              if (
                Object.prototype.hasOwnProperty.call(
                  resp,
                  'score_ts_itemized',
                ) &&
                // eslint-disable-next-line no-prototype-builtins
                resp['score_ts_itemized'][0]?.hasOwnProperty('score_ts')
              ) {
                let mappedResp = resp['score_ts_itemized'];
                const respCopy = JSON.parse(
                  JSON.stringify(resp['score_ts_itemized']),
                );
                if (
                  iparams.custom_payload ||
                  this.portfolioApi.activePortfolio.content
                ) {
                  const orderedChildren = [];
                  let body = [];
                  if (iparams.custom_payload) {
                    body = iparams.custom_payload;
                  } else {
                    body = this.portfolioApi.activePortfolio.content;
                  }
                  body.forEach((el) => {
                    const filteredEntity = respCopy.filter((item) => {
                      return item.entity_info.compound_key === el;
                    });
                    if (filteredEntity.length > 0) {
                      // orderedChildren.push(filteredEntity[0]);
                      orderedChildren.push(
                        Object.assign({}, filteredEntity[0], {
                          entity_info: {
                            compound_key: el,
                          },
                        }),
                      );
                    } else {
                      orderedChildren.push({
                        entity_info: {
                          compound_key: el,
                        },
                      });
                      console.log(
                        'The entity ' +
                          el +
                          ' is not present in the API response.',
                      );
                    }
                  });
                  mappedResp = orderedChildren;
                }
                return mappedResp.map((el) => {
                  if (
                    el &&
                    Object.prototype.hasOwnProperty.call(el, 'score_ts') &&
                    el['score_ts'].length > 0
                  ) {
                    const trend_type =
                      el['score_ts'][el['score_ts'].length - 1].score > 5.0
                        ? 'bull'
                        : 'bear';
                    const trend_value = el['score_ts'][
                      el['score_ts'].length - 1
                    ].score
                      ? el['score_ts'][el['score_ts'].length - 1].score.toFixed(
                          1,
                        )
                      : el['score_ts'][el['score_ts'].length - 1].score;
                    return {
                      entity_info: el['entity_info'],
                      // score_type: el['score_type'],
                      score_ts: el['score_ts'].map((el2) => {
                        const trend_type2 = el2.score > 5.0 ? 'bull' : 'bear';
                        const trend_value2 = el2.score
                          ? el2.score.toFixed(1)
                          : el2.score;
                        return {
                          date: el2.date,
                          score: el2.score,
                          trend_type: trend_type2,
                          trend_value: trend_value2,
                        };
                      }),
                      score_ts_last_score: {
                        date: el['score_ts'][el['score_ts'].length - 1].date,
                        score: el['score_ts'][el['score_ts'].length - 1].score,
                        trend_type: trend_type,
                        trend_value: trend_value,
                      },
                    };
                  } else {
                    return undefined;
                  }
                });
              } else {
                return resp;
              }
            }),
          );
        } else if (iparams.with_top_events) {
          if (iparams.top_events_sign === 'neg') {
            params['top_events_sign'] = iparams.top_events_sign;
          }
          delete params['with_top_events'];
          return forkJoin({
            count: this.iRequest(
              iparams,
              Object.assign({}, params, {
                top_events_ranking: 'absolute_count',
              }),
              'bull_bear_score_ts_top_events',
            ),
            importance: this.iRequest(
              iparams,
              Object.assign({}, params, {
                top_events_ranking: 'relative_importance',
              }),
              'bull_bear_score_ts_top_events',
            ),
          }).pipe(
            map((resp) => {
              const respCopy = JSON.parse(JSON.stringify(resp));
              const topEvents = respCopy.count;
              topEvents.top_events.forEach((event, index) => {
                const importanceEventInstance =
                  respCopy.importance.top_events?.filter(
                    (e) => e.id === event.id,
                  )[0];
                topEvents.top_events[index].contrib_amount_importance =
                  importanceEventInstance
                    ? importanceEventInstance.contrib_amount
                    : null;
              });
              return topEvents;
            }),
          );
        } else {
          return this.iRequest(iparams, params, 'bull_bear_score_ts').pipe(
            map((respArg) => {
              const resp = JSON.parse(JSON.stringify(respArg));
              if (
                Object.prototype.hasOwnProperty.call(resp, 'score_ts') &&
                resp['score_ts'].length > 0
              ) {
                const trend_type =
                  resp['score_ts'][resp['score_ts'].length - 1].score > 5.0
                    ? 'bull'
                    : 'bear';
                const trend_value =
                  resp['score_ts'][resp['score_ts'].length - 1].score.toFixed(
                    1,
                  );
                return {
                  // score_type: resp['score_type'],
                  score_ts: resp['score_ts'].map((el) => {
                    const trend_type2 = el.score > 5.0 ? 'bull' : 'bear';
                    const trend_value2 = el.score.toFixed(1);
                    return {
                      date: el.date,
                      score: el.score,
                      trend_type: trend_type2,
                      trend_value: trend_value2,
                    };
                  }),
                  score_ts_last_score: {
                    date: resp['score_ts'][resp['score_ts'].length - 1].date,
                    score: resp['score_ts'][resp['score_ts'].length - 1].score,
                    trend_type: trend_type,
                    trend_value: trend_value,
                  },
                };
              } else {
                return resp;
              }
            }),
          );
        }
      } else if (
        iparams.industry_bench &&
        ((!iparams.requestScore &&
          ['bb'].includes(this.auth.scorelabSettings.defaultScore)) ||
          (iparams.requestScore && ['bb'].includes(iparams.requestScore)))
      ) {
        if (iparams.itemized) {
          return this.iRequest(
            iparams,
            params,
            'bull_bear_score_ts_industry_bench_itemized',
          ).pipe(
            map((respArg) => {
              const resp = JSON.parse(JSON.stringify(respArg));
              if (
                Object.prototype.hasOwnProperty.call(
                  resp,
                  'score_ts_industry_bench_itemized',
                ) &&
                // eslint-disable-next-line no-prototype-builtins
                resp['score_ts_industry_bench_itemized'][0]?.hasOwnProperty(
                  'score_ts_industry_bench',
                )
              ) {
                let mappedResp = resp['score_ts_industry_bench_itemized'];
                const respCopy = JSON.parse(
                  JSON.stringify(resp['score_ts_industry_bench_itemized']),
                );
                if (
                  iparams.custom_payload ||
                  this.portfolioApi.activePortfolio.content
                ) {
                  const orderedChildren = [];
                  let body = [];
                  if (iparams.custom_payload) {
                    body = iparams.custom_payload;
                  } else {
                    body = this.portfolioApi.activePortfolio.content;
                  }
                  body.forEach((el) => {
                    const filteredEntity = respCopy.filter((item) => {
                      return item.entity_info.compound_key === el;
                    });
                    if (filteredEntity.length > 0) {
                      // orderedChildren.push(filteredEntity[0]);
                      orderedChildren.push(
                        Object.assign({}, filteredEntity[0], {
                          entity_info: {
                            compound_key: el,
                          },
                        }),
                      );
                    } else {
                      orderedChildren.push({
                        entity_info: {
                          compound_key: el,
                        },
                      });
                      console.log(
                        'The entity ' +
                          el +
                          ' is not present in the API response.',
                      );
                    }
                  });
                  mappedResp = orderedChildren;
                }

                return mappedResp.map((el) => {
                  if (
                    el &&
                    Object.prototype.hasOwnProperty.call(
                      el,
                      'score_ts_industry_bench',
                    ) &&
                    el['score_ts_industry_bench'].length > 0
                  ) {
                    const trend_type =
                      el['score_ts_industry_bench'][
                        el['score_ts_industry_bench'].length - 1
                      ].score > 5.0
                        ? 'bull'
                        : 'bear';
                    const trend_value = el['score_ts_industry_bench'][
                      el['score_ts_industry_bench'].length - 1
                    ].score
                      ? el['score_ts_industry_bench'][
                          el['score_ts_industry_bench'].length - 1
                        ].score.toFixed(1)
                      : el['score_ts_industry_bench'][
                          el['score_ts_industry_bench'].length - 1
                        ].score;
                    return {
                      entity_info: el['entity_info'],
                      // score_type: el['score_type'],
                      score_ts: el['score_ts_industry_bench'].map((el2) => {
                        const trend_type2 = el2.score > 5.0 ? 'bull' : 'bear';
                        const trend_value2 = el2.score
                          ? el2.score.toFixed(1)
                          : el2.score;
                        return {
                          date: el2.date,
                          score: el2.score,
                          trend_type: trend_type2,
                          trend_value: trend_value2,
                        };
                      }),
                      score_ts_last_score: {
                        date: el['score_ts_industry_bench'][
                          el['score_ts_industry_bench'].length - 1
                        ].date,
                        score:
                          el['score_ts_industry_bench'][
                            el['score_ts_industry_bench'].length - 1
                          ].score,
                        trend_type: trend_type,
                        trend_value: trend_value,
                      },
                    };
                  } else {
                    return undefined;
                  }
                });
              } else {
                return resp;
              }
            }),
          );
        } else {
          return this.iRequest(
            iparams,
            params,
            'bull_bear_score_ts_industry_bench',
          ).pipe(
            map((respArg) => {
              const resp = JSON.parse(JSON.stringify(respArg));
              if (
                Object.prototype.hasOwnProperty.call(
                  resp,
                  'score_ts_industry_bench',
                ) &&
                resp['score_ts_industry_bench'].length > 0
              ) {
                const trend_type =
                  resp['score_ts_industry_bench'][
                    resp['score_ts_industry_bench'].length - 1
                  ].score > 5.0
                    ? 'bull'
                    : 'bear';
                const trend_value =
                  resp['score_ts_industry_bench'][
                    resp['score_ts_industry_bench'].length - 1
                  ].score.toFixed(1);
                return {
                  // score_type: resp['score_type'],
                  score_ts: resp['score_ts_industry_bench'].map((el) => {
                    const trend_type2 = el.score > 5.0 ? 'bull' : 'bear';
                    const trend_value2 = el.score.toFixed(1);
                    return {
                      date: el.date,
                      score: el.score,
                      trend_type: trend_type2,
                      trend_value: trend_value2,
                    };
                  }),
                  score_ts_last_score: {
                    date: resp['score_ts_industry_bench'][
                      resp['score_ts_industry_bench'].length - 1
                    ].date,
                    score:
                      resp['score_ts_industry_bench'][
                        resp['score_ts_industry_bench'].length - 1
                      ].score,
                    trend_type: trend_type,
                    trend_value: trend_value,
                  },
                };
              } else {
                return resp;
              }
            }),
          );
        }
      } else if (iparams.industry_bench) {
        // delete params['disable_industry_materiality'];
        if (iparams.itemized) {
          return this.iRequest(
            iparams,
            params,
            'score_ts_industry_bench_itemized',
          ).pipe(
            map((respArg) => {
              const resp = JSON.parse(JSON.stringify(respArg));
              if (
                Object.prototype.hasOwnProperty.call(
                  resp,
                  'score_ts_industry_bench_itemized',
                )
              ) {
                if (
                  // eslint-disable-next-line no-prototype-builtins
                  resp['score_ts_industry_bench_itemized'][0]?.hasOwnProperty(
                    'score_ts_industry_bench',
                  )
                ) {
                  let mappedResp = resp['score_ts_industry_bench_itemized'];
                  const respCopy = JSON.parse(
                    JSON.stringify(resp['score_ts_industry_bench_itemized']),
                  );
                  if (
                    iparams.custom_payload ||
                    this.portfolioApi.activePortfolio.content
                  ) {
                    const orderedChildren = [];
                    let body = [];
                    if (iparams.custom_payload) {
                      body = iparams.custom_payload;
                    } else {
                      body = this.portfolioApi.activePortfolio.content;
                    }
                    body.forEach((el) => {
                      const filteredEntity = respCopy.filter((item) => {
                        return item.entity_info.compound_key === el;
                      });
                      if (filteredEntity.length > 0) {
                        // orderedChildren.push(filteredEntity[0]);
                        orderedChildren.push(
                          Object.assign({}, filteredEntity[0], {
                            entity_info: {
                              compound_key: el,
                            },
                          }),
                        );
                      } else {
                        orderedChildren.push({
                          entity_info: {
                            compound_key: el,
                          },
                        });
                        console.log(
                          'The entity ' +
                            el +
                            ' is not present in the API response.',
                        );
                      }
                    });
                    mappedResp = orderedChildren;
                  }
                  return mappedResp.map((el) => {
                    return {
                      entity_info: el['entity_info'],
                      // score_type: el['score_type'],
                      score_ts: el['score_ts_industry_bench'],
                      score_ts_last_score:
                        el['score_ts_industry_bench_last_score'],
                    };
                  });
                } else {
                  return resp['score_ts_industry_bench_itemized'];
                }
              } else {
                return throwError(
                  () => new Error('Error: wrong format of the response.'),
                );
              }
            }),
          );
        } else {
          return this.iRequest(iparams, params, 'score_ts_industry_bench').pipe(
            map((respArg) => {
              const resp = JSON.parse(JSON.stringify(respArg));
              if (
                Object.prototype.hasOwnProperty.call(
                  resp,
                  'score_ts_industry_bench',
                )
              ) {
                return {
                  // score_type: resp['score_type'],
                  score_ts: resp['score_ts_industry_bench'],
                  score_ts_last_score:
                    resp['score_ts_industry_bench_last_score'],
                };
              } else {
                return resp;
              }
            }),
          );
        }
      } else {
        if (iparams.with_top_events) {
          if (
            (!iparams.requestScore &&
              this.auth.scorelabSettings.defaultScore === 'credit_risk') ||
            (iparams.requestScore &&
              iparams.requestScore === 'credit_risk' &&
              !iparams.industry_bench)
          ) {
            if (iparams.top_events_sign === 'neg') {
              params['top_events_sign'] = iparams.top_events_sign;
            }
          }
          delete params['with_top_events'];
          return forkJoin({
            count: this.iRequest(
              iparams,
              Object.assign({}, params, {
                top_events_ranking: 'absolute_count',
              }),
              'score_ts_top_events',
            ),
            importance: this.iRequest(
              iparams,
              Object.assign({}, params, {
                top_events_ranking: 'relative_importance',
              }),
              'score_ts_top_events',
            ),
          }).pipe(
            map((resp) => {
              const respCopy = JSON.parse(JSON.stringify(resp));
              const topEvents = respCopy.count;
              topEvents.top_events.forEach((event, index) => {
                const importanceEventInstance =
                  respCopy.importance.top_events?.filter(
                    (e) => e.id === event.id,
                  )[0];
                topEvents.top_events[index].contrib_amount_importance =
                  importanceEventInstance
                    ? importanceEventInstance.contrib_amount
                    : null;
              });
              return topEvents;
            }),
          );
        } else if (iparams.itemized) {
          return this.iRequest(iparams, params, 'score_ts_itemized').pipe(
            map((respArg) => {
              const resp = JSON.parse(JSON.stringify(respArg));
              if (
                Object.prototype.hasOwnProperty.call(resp, 'score_ts_itemized')
              ) {
                // eslint-disable-next-line no-prototype-builtins
                if (resp['score_ts_itemized'][0]?.hasOwnProperty('score_ts')) {
                  let mappedResp = resp['score_ts_itemized'];
                  const respCopy = JSON.parse(
                    JSON.stringify(resp['score_ts_itemized']),
                  );
                  if (
                    iparams.custom_payload ||
                    this.portfolioApi.activePortfolio.content
                  ) {
                    const orderedChildren = [];
                    let body = [];
                    if (iparams.custom_payload) {
                      body = iparams.custom_payload;
                    } else {
                      body = this.portfolioApi.activePortfolio.content;
                    }
                    body.forEach((el) => {
                      const filteredEntity = respCopy.filter((item) => {
                        return item.entity_info.compound_key === el;
                      });
                      if (filteredEntity.length > 0) {
                        // orderedChildren.push(filteredEntity[0]);
                        orderedChildren.push(
                          Object.assign({}, filteredEntity[0], {
                            entity_info: {
                              compound_key: el,
                            },
                          }),
                        );
                      } else {
                        orderedChildren.push({
                          entity_info: {
                            compound_key: el,
                          },
                        });
                        console.log(
                          'The entity ' +
                            el +
                            ' is not present in the API response.',
                        );
                      }
                    });
                    mappedResp = orderedChildren;
                  }
                  return mappedResp;
                } else {
                  return resp['score_ts_itemized'];
                }
              } else {
                return throwError(
                  () => new Error('Error: wrong format of the response.'),
                );
              }
            }),
          );
        } else {
          return this.iRequest(iparams, params, 'score_ts');
        }
      }
    }
    if (type === 'yl_price') {
      delete params['period'];
      delete params['project'];
      delete params['feed_types'];
      delete params['lang'];
      const options = this.getOption(params);
      const requestUrl = `${this.apiurlQuant}/trading/${iparams['type']}/${iparams['id']}/yl_price`;
      return this.http.get(requestUrl, options).pipe(
        timeout(2000),
        catchError((err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.error('An error occurred:', err.error.message);
          } else {
            console.error(
              `Backend returned code ${err.status}, body was: ${err.error}`,
            );
          }
          return of({ prices: [], currency: [] });
        }),
      );
    }

    if (['price', 'price_delta', 'volatility'].includes(type)) {
      const options = this.getOption(params);
      let body = [];
      if (iparams.custom_payload) {
        body = iparams.custom_payload;
      } else {
        body = this.portfolioApi.activePortfolio
          ? this.portfolioApi.activePortfolio.content
          : [];
      }
      const requestUrl = `${this.apiurlQuant}/trading/portfolio/price_data_itemized?type=${type}`;
      return this.http.post(requestUrl, body, options).pipe(
        timeout(2000),
        map((resp) => {
          return resp['price_data_itemized'];
        }),
        catchError((err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.error('An error occurred:', err.error.message);
          } else {
            console.error(
              `Backend returned code ${err.status}, body was: ${err.error}`,
            );
          }
          return of({ price_data_itemized: body.map(() => [{ value: null }]) });
        }),
      );
    }
  }

  /**
   * parse isin list
   */
  isinParse(isins): Observable<any> {
    const options = this.getOption(null);
    const requestUrl = `${this.apiurlMetadata}/isin_to_entity`;
    return this.http.post(requestUrl, isins, options);
  }

  /**
   * get more detailed info about entities based on compound_key value
   */
  getEntitiesInfo(
    entitiesArray,
    format = 'object',
    sanctions = false,
  ): Observable<any> {
    let options;
    if (
      (this.routing.isReader() || this.routing.isStoryReader()) &&
      this.auth.tokenDataAccess
    ) {
      options = this.getOption({ jwt: this.auth.tokenDataAccess });
    } else {
      options = this.getOption(null);
    }
    const requestUrl = `${this.apiurlMetadata}/entity_info`;

    return forkJoin([
      this.http.post(requestUrl, entitiesArray, options),
      sanctions ? this.getSanctionsInfo(entitiesArray) : of({ sanctions: [] }),
    ]).pipe(
      map((res) => {
        const respCopy = JSON.parse(JSON.stringify(res[0]));
        const sanctionsCopy = JSON.parse(JSON.stringify(res[1]));
        respCopy.forEach((entity, index) => {
          const sanctionsArray = [];
          sanctionsCopy['sanctions'].forEach((s) => {
            if (entity.compound_key === s.sanctioned_entity.compound_key) {
              sanctionsArray.push(s);
            }
          });
          respCopy[index]['sanctions'] = sanctionsArray;
        });
        entitiesArray.forEach((el) => {
          const filteredEntity = respCopy.filter((item) => {
            return item.compound_key === el;
          });
          if (!(filteredEntity.length > 0)) {
            console.log(
              'The entity ' +
                el +
                ' is not present in the metadata API response.',
            );
          }
        });
        if (format === 'object') {
          const resObject = {};
          respCopy.forEach((el) => {
            resObject[el.compound_key] = el;
          });
          return resObject;
        } else {
          return respCopy;
        }
      }),
      catchError((error) => throwError(() => error)),
    );
  }

  /**
   * get info about sanctioned entities based on the compound_key value
   */
  getSanctionsInfo(entitiesArray) {
    const options = this.getOption(null);
    const requestUrl = `${this.apiurlMetadata}/sanctions/entity`;
    return this.http.post(requestUrl, entitiesArray, options).pipe(
      map((res) => res),
      catchError((error) => {
        console.log(error);
        return of({ sanctions: [] });
      }),
    );
  }

  /**
   * get related entities info
   */
  getRelatedEntitiesInfo(type, id, filter): Observable<any> {
    const options = this.getOption(null);
    const requestUrl = `${this.apiurlMetadata}/related/${type}.${id}?entity_type_filter=${filter}`;
    return this.http.get(requestUrl, options);
  }

  /**
   * get hierarchy info
   */
  getHierarchyInfo(type, iparams): Observable<any> {
    const paramsToBeSent = [
      'period',
      'with_top_events',
      'with_all_events',
      ...this.paramsForAllRequests,
    ];
    let params = {};
    params = this.myParams(iparams, paramsToBeSent);
    const options = this.getOption(params);
    if (['icb', 'event'].includes(type)) {
      const requestUrl = `${this.apiurlMetadata}/hierarchy/${type}`;
      return this.http.get(requestUrl, options);
    } else {
      // const requestUrl = `${this.apiurlQuant}/signal/market_board?board_type=${type}&score_type=${this.auth.scorelabSettings.defaultScore}`;
      const requestUrl = `${this.apiurlQuant}/signal/market_board?board_type=${type}`;
      return this.http.get(requestUrl, options);
    }
  }

  /**
   * get countries list
   */
  getCountries(): Observable<any> {
    const options = this.getOption(null);
    const requestUrl = `${this.apiurlMetadata}/grouping_info/countries`;
    return this.http.get(requestUrl, options);
  }

  /**
   * get continents list
   */
  getContinents(): Observable<any> {
    const options = this.getOption(null);
    const requestUrl = `${this.apiurlMetadata}/grouping_info/continents`;
    return this.http.get(requestUrl, options);
  }
}
